module.exports = __webpack_public_path__ + "img/showImg1.b41a63b9.png";